/**
 * normalize vehicle core data into vehicel state
 * @param vehicleData: SAGASERVICEONLY_IVehicle
 * @returns IVehicle
 */
export const normalizeVehicleData = (vehicleData) => {
    var _a, _b, _c, _d, _e;
    return {
        vin: vehicleData.vin,
        vid: vehicleData.vid,
        serviceYear: vehicleData.year,
        make: vehicleData.make,
        makeId: (_a = vehicleData.makeId) !== null && _a !== void 0 ? _a : vehicleData.makeId,
        model: vehicleData.model,
        modelId: (_b = vehicleData.modelId) !== null && _b !== void 0 ? _b : vehicleData.modelId,
        subModel: vehicleData.subModel,
        subModelId: vehicleData.subModelId,
        engineDescription: vehicleData.engine,
        engineId: vehicleData.engineId,
        serviceBarcode: vehicleData.serviceBarcode,
        typeId: (_c = vehicleData.typeId) !== null && _c !== void 0 ? _c : vehicleData.typeId,
        vehicleType: vehicleData.type,
        fuelTypeId: vehicleData.fuelTypeId,
        fuelType: vehicleData.fuelType,
        nadaVid: vehicleData.nadaVid,
        pinVid: vehicleData.pinVid ? +vehicleData.pinVid : undefined,
        styleId: vehicleData.styleId,
        bodyStyle: vehicleData.bodyStyle,
        bodyStyleId: vehicleData.bodyStyleId,
        sourceVid: vehicleData.sourceVid,
        redbookControlNumber: vehicleData.redbookControlNumber,
        description: { value: vehicleData.description },
        customVehicleName: vehicleData.customVehicleName,
        isCustomVehicleNameSelected: vehicleData.isCustomVehicleNameSelected,
        driveTrain: vehicleData.driveTrain,
        driveTrainId: vehicleData.driveTrainId,
        transmission: vehicleData.transmission,
        transmissionId: vehicleData.transmissionId,
        odometer: vehicleData.odometer,
        vehicleSelectionMethod: vehicleData.vehicleSelectionMethod,
        salvageValue: { value: vehicleData.salvageValue },
        isFleet: vehicleData.isFleet,
        primaryPointOfImpact: (_d = vehicleData.status) === null || _d === void 0 ? void 0 : _d.primaryPointOfImpact,
        secondaryPointsOfImpact: (_e = vehicleData.status) === null || _e === void 0 ? void 0 : _e.secondaryPointsOfImpact
    };
};
/**
 * denormalize vehicle state data to service format
 * @param vehicleStateData
 * @returns
 */
export const denormalizeVehicleData = (vehicleStateData) => {
    var _a, _b;
    return {
        vin: vehicleStateData.vin,
        vid: vehicleStateData.vid,
        year: vehicleStateData.serviceYear,
        make: vehicleStateData.make,
        makeId: vehicleStateData.makeId,
        model: vehicleStateData.model,
        modelId: vehicleStateData.modelId,
        engine: vehicleStateData.engineDescription,
        engineId: vehicleStateData.engineId,
        serviceBarcode: vehicleStateData.serviceBarcode,
        typeId: vehicleStateData.typeId,
        type: vehicleStateData.vehicleType,
        fuelTypeId: vehicleStateData.fuelTypeId,
        fuelType: vehicleStateData.fuelType,
        nadaVid: vehicleStateData.nadaVid,
        pinVid: vehicleStateData.pinVid,
        styleId: vehicleStateData.styleId,
        bodyStyle: vehicleStateData.bodyStyle,
        bodyStyleId: vehicleStateData.bodyStyleId,
        sourceVid: vehicleStateData.sourceVid,
        redbookControlNumber: vehicleStateData.redbookControlNumber,
        description: ((_a = vehicleStateData.description) === null || _a === void 0 ? void 0 : _a.value) || '',
        customVehicleName: vehicleStateData.customVehicleName || '',
        isCustomVehicleNameSelected: vehicleStateData.isCustomVehicleNameSelected,
        driveTrain: vehicleStateData.driveTrain,
        driveTrainId: vehicleStateData.driveTrainId,
        transmission: vehicleStateData.transmission,
        transmissionId: vehicleStateData.transmissionId,
        subModel: vehicleStateData.subModel || '',
        subModelId: vehicleStateData.subModelId,
        odometer: vehicleStateData.odometer,
        salvageValue: (_b = vehicleStateData.salvageValue) === null || _b === void 0 ? void 0 : _b.value,
        isFleet: vehicleStateData.isFleet
    };
};
//# sourceMappingURL=VehicleOperations.js.map